
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.614 19.56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_773","data-name":"Path 773","d":"M48,11.147l.55-3.587H45.106V5.233A1.794,1.794,0,0,1,47.128,3.3h1.564V.242A19.088,19.088,0,0,0,45.915,0c-2.834,0-4.686,1.717-4.686,4.827V7.56H38.078v3.587h3.151V19.56h3.877V11.147Z","transform":"translate(-38.078)","fill":"currentColor"}})])
          )
        }
      }
    